import { ADDRESS_TEXT_MAX_LENGTH } from '~/lib/geo-providers/ADDRESS_TEXT_MAX_LENGTH'

const LOCATABLE_CHARACTER = /[\p{L}\p{N}]/u

/** True when typed address text fits the search `q` limit and has a letter or digit for the server to geocode. */
export function isLocatableAddressText(text: string): boolean {
  return text.trim().length <= ADDRESS_TEXT_MAX_LENGTH && LOCATABLE_CHARACTER.test(text)
}
